const React = require('react')
const { useEffect, useState } = require('react')
const { Container, Row, Col } = require('reactstrap')
const { useParams, useHistory } = require('react-router-dom')
const { useBlockchainData } = require('@hooks')
const { useNetworkConfig } = require('@contexts')
const { TableCountdownBlockTime, TableCountdownBlockInfo } = require('./table.countdown.block')

require('@styles/pages/block/countdown/index.css')

const BlockCountdown = () => {
    const history = useHistory()
    const { blockNumber } = useParams()
    const { network } = useNetworkConfig()
    const { getBlock, getBlocks } = useBlockchainData(network.name)

    const [loading, setLoading] = useState(true)
    const [currentBlockNumber, setCurrentBlockNumber] = useState(null)
    const [blocksUntilTarget, setBlocksUntilTarget] = useState(null)
    const [targetBlockTimestamp, setTargetBlockTimestamp] = useState(null)
    const [timeUntilTarget, setTimeUntilTarget] = useState(0)
    const [displayTime, setDisplayTime] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    })

    const calculateDisplayTime = seconds => {
        const days = Math.floor(seconds / (24 * 60 * 60))
        const hours = Math.floor((seconds % (24 * 60 * 60)) / (60 * 60))
        const minutes = Math.floor((seconds % (60 * 60)) / 60)
        const remainingSeconds = Math.floor(seconds % 60)

        return { days, hours, minutes, seconds: remainingSeconds }
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                setCurrentBlockNumber(null)
                setBlocksUntilTarget(null)
                setTargetBlockTimestamp(null)
                setTimeUntilTarget(0)

                const [blocksResponse] = await Promise.all([getBlocks(1, 1)])

                if (blocksResponse) {
                    const latestBlock = blocksResponse.totalItems - 1
                    const blocksRemaining = parseInt(blockNumber) - latestBlock
                    const [currentBlockData] = await Promise.all([getBlock(latestBlock)])
                    const estimatedTargetTime =
                        currentBlockData.timestamp + blocksRemaining * network.data.averageBlockTime
                    const secondsUntilTarget = estimatedTargetTime - Math.floor(Date.now() / 1000)

                    if (parseInt(blockNumber) <= latestBlock) {
                        history.push(`/${network.name}/block/${blockNumber}`)
                        return
                    }

                    setCurrentBlockNumber(latestBlock)
                    setBlocksUntilTarget(blocksRemaining)
                    setTargetBlockTimestamp(estimatedTargetTime)
                    setTimeUntilTarget(secondsUntilTarget)
                }
                setLoading(false)
            } catch (error) {
                console.error('Error fetching data:', error)
                setLoading(false)
            }
        }

        fetchData()
    }, [blockNumber])

    useEffect(() => {
        if (timeUntilTarget > 0) {
            setDisplayTime(calculateDisplayTime(timeUntilTarget))
            const interval = setInterval(() => {
                setTimeUntilTarget(prev => {
                    const newTime = prev - 1
                    if (newTime >= 0) {
                        setDisplayTime(calculateDisplayTime(newTime))
                    }
                    return newTime
                })
            }, 1_000)

            return () => clearInterval(interval)
        }
    }, [timeUntilTarget])

    return (
        <div className='page'>
            <Container>
                <Row>
                    <Col md='4' style={{ position: 'relative' }}>
                        <div style={{ position: 'absolute', bottom: '0' }}>
                            <img
                                src='https://etherscan.io/assets/svg/block-countdown/block-countdown-light.svg'
                                alt='Block Countdown'
                                className='img-fluid'
                            />
                        </div>
                    </Col>

                    <Col md='8'>
                        <div className='page-header'>
                            <text className='page-title'>Block Countdown</text>
                            <text className='page-subtitle'>
                                The estimated time for a block to be created and added to the blockchain.
                            </text>
                            <div className='page-title-border' />
                        </div>
                        <Row>
                            <Col md='6'>
                                <div className='box table-section'>
                                    <TableCountdownBlockTime
                                        loading={loading}
                                        item={{ displayTime, targetBlockTimestamp }}
                                    />
                                </div>
                            </Col>
                            <Col md='6'>
                                <div className='box table-section'>
                                    <TableCountdownBlockInfo
                                        loading={loading}
                                        item={{ blockNumber, blocksUntilTarget, currentBlockNumber }}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

module.exports = BlockCountdown
